import { useIsFeatureEnabled } from '@innovyze/stylovyze';

export const useIsFeatureEnabledSafe = useIsFeatureEnabled as unknown as (
	name: string,
) => boolean;

export const useIsUserManagementForgeEnabled = () =>
	useIsFeatureEnabledSafe('info-360-user-management-forge');
